export default __webpack_public_path__ + "static/media/adnan.964683a3.jpeg";